// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__3XKCc","fieldName":"styles_fieldName__Ls70N","input":"styles_input__2cSWu","inputcontact":"styles_inputcontact__vnpS9","inputNew":"styles_inputNew__2nu4U"};